import React from 'react';
import { Link } from 'react-router-dom';
import { LOGO_DARK } from '../config';

const GiftSuccessPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-pink-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
        <div className="w-20 h-20 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <span className="text-5xl">🎁</span>
        </div>
        
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          Gift Sent!
        </h1>
        
        <p className="text-gray-600 mb-6">
          Thank you for your purchase! We've sent gift instructions to your friend's email address.
        </p>
        
        <div className="bg-purple-50 border border-purple-200 rounded-xl p-4 mb-6">
          <p className="text-purple-800 text-sm">
            <strong>What happens next?</strong><br />
            Your friend will receive an email with instructions on how to redeem their gift and start their Daily Discipline journey.
          </p>
        </div>
        
        <Link
          to="/"
          className="inline-block w-full bg-purple-600 hover:bg-purple-700 text-white font-semibold py-3 px-6 rounded-xl transition"
        >
          Back to Home
        </Link>
        
        <div className="mt-6 pt-6 border-t border-gray-100">
          <img src={LOGO_DARK} alt="Daily Discipline" className="h-8 w-8 mx-auto opacity-50" />
        </div>
      </div>
    </div>
  );
};

export default GiftSuccessPage;
